import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'doubleHyphen',
	standalone: true,
})
export class DoubleHyphenPipe implements PipeTransform {

	transform(value: string, ...args: unknown[]): string {
		return (value) ? value : '--';
	}

}
